import client from './main-client';

export const fetchLendersApi = (params) => client().get('/lender-company-categories', { params });
